module.exports = __webpack_public_path__ + "media/gem-found-purple.80bfe5c5.mp4";